import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import { makeStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import i18n from 'i18next';
import React, { useMemo } from 'react';
import { ChangeCityLiPrice } from '../../actions/cities';
import { Alert as MuiAlert } from '@mui/material';
import { getCurrentCurrency } from '../../actions/currencies';
import { domain } from '../../i18n';

const useStyles = makeStyles({
    root: {
        maxWidth: 325,
        marginRight: '7px',
        marginBottom: '7px',
        minHeight: '265px',
        minWidth: '325px',
    },
});

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function SummerIntencive({ recivedPrice = null }) {
    const currency = useMemo(() => {
        return getCurrentCurrency();
    }, []);
    const classes = useStyles();
    const [price, setPrice] = React.useState(0);
    const [loading, setLoader] = React.useState(false);

    const handleChange = e => {
        const value = e.target.value;
        setPrice(value);
    };
    const handleCityPriceChange = async e => {
        e.preventDefault();
        if (!price) return;
        setLoader(true);
        await ChangeCityLiPrice({
            avg_proce_li: +price <= 0 ? -1 : +price,
            min_price_offline_li: recivedPrice?.min_price_offline_li,
        });
        setLoader(false);
        setPrice(0);
    };

    const [open, setOpen] = React.useState(false);

    const handleClick = () => {
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };
    return (
        <Card className={classes.root} elevation={0}>
            <Box p={2} display="flex" flexDirection="column" justifyContent="space-between" height="95%">
                <Typography gutterBottom variant="h5" component="h2">
                    {i18n.t('payments.liPrice')}
                </Typography>
                <Box>
                    <Typography
                        gutterBottom
                        variant="h6"
                        component="h6"
                        style={{ fontSize: '14px', marginBottom: '15px' }}
                    >
                        {`${i18n.t(`payments.current_price`)}: `}
                        <span className={`cityPrice ${+recivedPrice?.avg_proce_li <= 0 ? 'not_shown' : 'ok'}`}>
                            {recivedPrice?.avg_proce_li <= 0 ? 0 : recivedPrice?.avg_proce_li} {currency}
                        </span>
                    </Typography>
                    <Typography
                        gutterBottom
                        variant="h6"
                        component="h6"
                        style={{ fontSize: '14px', marginBottom: '15px' }}
                    >
                        {`${i18n.t(`payments.min_price`)}: `}
                        <span className={`cityPrice ${+recivedPrice?.min_price_offline_li <= 0 ? 'not_shown' : 'ok'}`}>
                            {recivedPrice?.min_price_offline_li <= 0 ? 0 : recivedPrice?.min_price_offline_li}{' '}
                            {currency}
                        </span>
                    </Typography>

                    {+recivedPrice?.avg_proce_li <= 0 ? (
                        <Typography
                            gutterBottom
                            variant="subtitle2"
                            component="p"
                            className="red"
                            style={{ marginTop: '15px', color: '#f36630' }}
                        >
                            * {i18n.t('payments.liNotShown')}
                        </Typography>
                    ) : null}
                    <form onSubmit={handleCityPriceChange}>
                        <CardActions
                            style={{
                                padding: '0px',
                                marginTop: '15px',
                                marginBottom: '15px',
                            }}
                        >
                            <TextField
                                fullWidth
                                type="number"
                                disabled={loading}
                                className="cityPriceChange"
                                value={price || ''}
                                onChange={handleChange}
                                name="price"
                                variant="outlined"
                                label={`${i18n.t(`table.price`)} ${currency}`}
                            />
                        </CardActions>
                        <Button
                            fullWidth
                            style={{
                                margin: '0!important',
                                marginTop: '20px!important',
                                color: '#fff',
                            }}
                            size="medium"
                            disabled={loading || !price}
                            className={'bossButton'}
                            onClick={handleCityPriceChange}
                        >
                            {loading ? <CircularProgress color="inherit" size={20} /> : i18n.t('buttons.save')}
                        </Button>
                    </form>

                    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                        <Alert onClose={handleClose} severity="info">
                            {i18n.t('payments.alert_message')}
                        </Alert>
                    </Snackbar>
                </Box>
            </Box>
        </Card>
    );
}
